<template>
    <v-dialog
        v-model="dialog"
        width="500"
      >
        <v-btn
          slot="activator"
          color="teal lighten-1"
          dark
          fixed
          bottom
          right
          fab
        >
          <v-icon x-large>more_vert</v-icon>
        </v-btn>  

        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            How to Use
          </v-card-title>
  
          <v-card-text>
            Click the <v-icon class="example">menu</v-icon> button in the top left corner to switch between data sets. Click on an individual line item to expand its contents for a further explanation of the data. 
            <br><br>
            All figures and data shown on this page are presented by Pawtocol and subject to change.
          </v-card-text>
  
          <v-divider></v-divider>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              @click="dialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    }
  }
}    
</script>

<style>
  
</style>